import { IApplicationState } from '../../types/redux';

export const selectSavedSearches = (state: IApplicationState) => state.savedSearches;
